// contexts/controleBar/mesas/MesaContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchData, postData, putData, deleteData } from '../../../services/Api';
import { useAlert } from '../../geral/AlertContext';
import { useMessage } from '../../geral/MessageContext';
import { useSSE } from '../../geral/SSEContext';

const MesaContext = createContext();

export const useMesa = () => useContext(MesaContext);

export const MesaProvider = ({ children }) => {
    const [mesas, setMesas] = useState([]);
    const [mesaSel, setMesaSel] = useState([]);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();
    const { subscribeToEvent } = useSSE();

    const fetchMesas = useCallback(async () => {
        try {
            const result = await fetchData('/Mesa/GetMesas');
            setMesas(result);
        } catch (error) {
            console.error("Erro ao buscar mesas:", error);
            showMessage(`Erro ao buscar mesas! ${error?.message || error}`, 'danger');
        }
    }, []);

    useEffect(() => {
        fetchMesas();
    }, [fetchMesas]);

    useEffect(() => {
        return subscribeToEvent('controlebar-mesa', () => {
            fetchMesas();
        });
    }, [fetchMesas, subscribeToEvent]);

    const fetchMesaById = async (mesaId) => {
        try {
            //const response = await api.get(`/mesas/${mesaId}`); // Endpoint para buscar uma mesa específica
            const response = await fetchData('/Mesa/GetMesaById', { mesaId });
            setMesaSel(response);
            return response;
        } catch (error) {
            console.error(`Erro ao buscar mesa ${mesaId}:`, error);
            throw error;
        }
    };

    const fetchMesaByMesaConfId = async (mesaConfId) => {
        try {
            const response = await fetchData('/Mesa/GetMesaByMesaConfId', { mesaConfId });
            setMesaSel(response);
            return response;
        } catch (error) {
            console.error(`Erro ao buscar mesaConf ${mesaConfId}:`, error);
            throw error;
        }
    };

    const addMesa = async (mesa) => {
        try {
            const result = await postData('/Mesa', mesa);
            setMesas(prev => [...prev, result]);
            showAlert('Mesa adicionada com sucesso!');
            return result;
        } catch (error) {
            console.error("Erro ao adicionar mesa:", error);
            showMessage('Erro ao adicionar mesa!\n' + error, 'danger');
        }
    };

    const updateMesa = async (mesa) => {
        try {
            const result = await putData('/Mesa', mesa);
            setMesas(prev =>
                prev.map(m => (m.id === result.id ? result : m))
            );
            showAlert('Mesa alterada com sucesso!');
            return result;
        } catch (error) {
            console.error("Erro ao atualizar mesa:", error);
            showAlert('Erro ao alterar mesa!', 'danger');
            throw error;
        }
    };

    const deleteMesa = async (id) => {
        try {
            await deleteData('/Mesa', { id });
            setMesas(prev => prev.filter(m => m.id !== id));
            showAlert('Mesa excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir mesa:", error);
            showAlert('Erro ao excluir mesa!' + (error?.data || error?.message || ''), 'danger');
        }
    };

    return (
        <MesaContext.Provider value={{ mesas, mesaSel, setMesaSel, 
            addMesa, updateMesa, deleteMesa, 
            fetchMesas, fetchMesaById, fetchMesaByMesaConfId }}>
            {children}
        </MesaContext.Provider>
    );
};
